import { updateField } from 'vuex-map-fields';

let timeoutId = null

export default {
  updateField (state, payload) {
    if (timeoutId) clearTimeout(timeoutId)

    timeoutId = setTimeout(() => updateField(state, payload), 100)
  }
}